module.exports = __webpack_public_path__ + "static/media/kaltbach_logo.489951cb.svg";